module.exports = __webpack_public_path__ + "img/chinesecompany212.66270fa4.png";